// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header{text-align:center}header img{max-width:350px}header h1{color:#7b6d69;text-decoration:underline}#precartProps{display:flex;flex-wrap:wrap;padding:15px}.precart-PropTypes{flex:0 0 30%;padding:0 15px}.precart-PropTypes label{display:block}#ssr>sbx-pcc{display:none}", ""]);
// Exports
module.exports = exports;
